<template>
    <div>
        <BTable small striped bordered :items="reduction.positions" :fields="fields">
            <template v-slot:cell(cur_step)="{ value, item, field: { key },index}">
                
                <BFormInput
                    v-model="item[key]"
                    type="text"
                    v-on:keyup="chkdot(item,key,$event)"
                    :class="isvalid_step(item)?'':'text-danger'" :title="'Крок зниження ціни не менше '+ item.min_step"
                />
                
            </template>
            
            <template v-slot:cell(new_cost)="{ value, item, field: { key },index}">
                <span :class="isvalid_step(item)?'':'text-danger'">
                    <b> {{parseFloat(item.cur_cost - item.cur_step).toFixed(2) }}</b>
                </span>
            </template>
            
            <template v-slot:cell(action)="{ value, item, field: { key },index}">
                <BButton :variant="variant(item)" v-on:click="make_bind(item)" :disabled="chkActive(item.id)">Ставка</BButton>
            </template>
            
        </BTable>
    </div>
</template>

<script>


import {createHelpers} from 'vuex-map-fields';

const {mapFields} = createHelpers({
    getterType: 'reduction/getReductionField',
    mutationType: 'reduction/updateReductionField',
});

import {
    BTooltip,
    BTable,
    BButton,
    BFormInput
} from 'bootstrap-vue-next';

export default {
    name: "positions",
    
    components:{
        BTable,
        BButton,
        BFormInput
    },
    
    data() {
        return {
            
            opt_original: ["Оригінал","Аналог"],
            fields: [
                {key: 'title',label: "Позиція",class:"align-middle"},
                {key: 'catalog_number',label: "Кат. номер",class:"align-middle"},
                {key: 'is_original',label: "Оригінал",class:"align-middle"},
                {key: 'unit',label: "Од.",class:"align-middle"},
                {key: 'quantity',label: "К-сть",class:"align-middle text-right"},
                {key: 'note',label: "Примітка",class:"align-middle"},
                {key: 'cur_cost',label: "Ціна поточна (без пдв)",class:"align-middle text-right"},
                {key: 'full_cost',label: "Сума поточна (без пдв)",class:"align-middle text-right"},
                {key: 'cur_step',label: "Крок пониження ціни",class:"align-middle text-right"},
                {key: 'new_cost',label: "Пропозиція ціни (без пдв)",class:"align-middle text-right"},
                {key: 'action',label: "Ставка",class:"align-middle"},
            ],
        }
    },
    
    mounted() {
    
    
    },
    
    created() {
    
    },
    
    computed: {
        ...mapFields([
            'reduction',
            'locked'
        ]),
    },
    
    methods:{
        variant(item) {
            let variant = 'danger';
            if (item.class == 'table-success') {
                variant = 'success';
            }
            return variant;
        },
        
        chkActive(item_id) {
            let active;
            active = (this.locked.findIndex((element) => {element == item_id}) == -1) ? false : true;
            return active;
        },
        
        isvalid_step (item) {
            let is_bigger_zero = parseFloat(item.cur_cost - item.cur_step).toFixed(2);
            let is_step_bigger_min = parseFloat(item.cur_step) >= parseFloat(item.min_step)
            return (is_bigger_zero >= 0 && is_step_bigger_min);
        },
        
        restrictDecimal (item) {
            item=item.match(/^\d+\.?\d{0,2}/);
        },
        
        make_bind (item) {
            IMC_CORE.showloading();
            EventBus.$emit('make_bid',item);
        },
        
        chkdot(item,key,event) {
            
            let tmp = item[key];
            
            tmp = tmp.replace(/[^0-9,.]/g, "");
            tmp = tmp.replace(/,/, ".");
            
            if (tmp.toString().includes('.') && (tmp.toString().split('.').pop().length > 2 || tmp.toString().split('.').length > 2)) {
                tmp = parseFloat(tmp).toFixed(2);
                tmp = isNaN(tmp) ? 0 : tmp;
            }
            // set element value to new value
            item[key] = tmp;
        },
        
    }
    
}

</script>


